import {useEffect, useState} from "react";

const YAWidget = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className="d-flex flex-column justify-content-between">
            <div className="text-center fs-2 font-bold">Отзывы о нас</div>
            <div style={{
                width: isMobile? 360:560,
                height: isMobile? 560: 800,
                overflow: "hidden",
                position: "relative"
            }}>
                <iframe style={{
                    width:'100%',
                    height:'100%',
                    border:'1px solid #e6e6e6',
                    borderRadius:'8px',
                    boxSizing:'border-box'
                }}
                        src="https://yandex.ru/maps-reviews-widget/99680966099?comments"></iframe>
                <a href="https://yandex.ru/maps/org/obrazovatelny_kompleks_im_m_k_tenishevoy/99680966099/" target="_blank"
                   style={{
                       boxSizing:"border-box",
                       textDecoration:'none',
                       color:'#b3b3b3',
                       fontSize:'10px',
                       fontFamily:'YS Text,sans-serif',
                       padding:'0 20px',
                       position:'absolute',
                       bottom:'8px',
                       width:'100%',
                       textAlign:'center',
                       left:0,
                       overflow:'hidden',
                       textOverflow:'ellipsis',
                       display:'block',
                       maxHeight:'14px',
                       whiteSpace:'nowrap'
                }}>
                    Образовательный комплекс им. М. К. Тенишевой на карте Смоленска — Яндекс Карты</a>
            </div>
        </div>
    )}

export default YAWidget;